import * as React from "react"
import { MainPage } from "@organic-return/foundation-gatsby-plugin-drupal/src/templates/MainPage"
import { graphql } from "gatsby"
import * as sections from "../../../components/sections"
import { useSiteContext } from "@organic-return/foundation-gatsby-plugin-drupal/src/components/common/SiteContext"

const IndexPage = (props: any) => {
  const siteContext = useSiteContext()
  const { page } = props.data

  var pageTitle = page.pageTitle ?? "";
  var pageDescription = page.metaDescription ?? "";
  
  return (
    <>
      <MainPage
        seoProps={{
          title: pageTitle,
          description: pageDescription,
          keywords: page.metaKeywords,          
          headScripts: page.headScripts,
        }}
        headerProps={{
          gradient: true,
          ...siteContext.headerProps,
        }}
        className={`content-page page-South-Berwick-Maine-Properties-For-Sale`}
      >
        {page.blocks.map((block: any) => {
          const { id, blocktype, ...componentProps } = block
          const Component = (sections as any)[blocktype]
          return <Component key={id} {...componentProps} />
        })}
      </MainPage>
    </>
  )
}

export default IndexPage

export const query = graphql`
{
  page: drupalNodeSitePage(title: {eq:"South Berwick Maine Properties Page"}) {
      title
      pageTitle
      metaDescription
      metaKeywords
      headScripts
      blocks: content {
        id
        blocktype
        ...DrupalHeadingContent
        ...DrupalListingSearchContent
        ...DrupalContactFormContent
      }
  }
}
`